export const CONFIG_ENV_JSON_PATH = '/assets/config/env.json';
export const CONFIG_ENV_HMG_JSON_PATH = '/assets/config/env-hmg.json';
